import { useEffect, useState } from 'react'

import { TourFlights } from 'shared/api/tours/flights'
import {
  type Flight,
  type RawTourFlight,
  mapRawTourFlightToDisplayFlight,
} from 'shared/api/tours/flights'

export const useFlights = (tourId?: string, operator?: string) => {
  const [flights, setFlights] = useState<Flight[]>([])
  const [rawFlights, setRawFlights] = useState<RawTourFlight[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchFlights = async (tourId: string) => {
      if (!tourId) return

      setIsLoading(true)
      setError(false)

      try {
        const { data: response } = await TourFlights.getFlights(
          tourId,
          operator,
        )

        const nextRawFlights = response.data?.length ? [response.data] : []
        const nextFlights = nextRawFlights
          .map(mapRawTourFlightToDisplayFlight)
          .filter((item): item is Flight => item != null)

        setRawFlights(nextRawFlights)
        setFlights(nextFlights)
      } catch (err) {
        setFlights([])
        setRawFlights([])
        setError(true)
      } finally {
        setIsLoading(false)
      }
    }

    if (tourId) {
      void fetchFlights(tourId)
    }
  }, [tourId, operator])

  return {
    flights,
    rawFlights,
    isLoading,
    error,
  }
}
